// Page List Without Footer Navigation
const withoutFooterNavPageList = ["payment", "es/payment", "thank-you", "es/thank-you"];

export default withoutFooterNavPageList;
